import { z } from 'zod';

/**
 * This type is a representation of `JupiterDBTypes['CustomSubscription']`.
 * IMPORTANT: we don't import the `JupiterDBTypes['CustomSubscription']` type directly
 * because we do not want to add a `jupiter-db` dependency to the common contracts.
 */
export const JupiterCustomSubscription = z.object({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  userId: z.string(),
  bundleId: z.string(),
  isActive: z.boolean(),
  period: z.enum(['lifetime', 'monthly', '3 months', '24h', 'yearly', 'custom']),
  provider: z.enum(['Custom', 'RevenueCat']),
  type: z.enum(['PointsAdd', 'Unlimited']),
  expiresAt: z.string().nullable(),
  periodLength: z.number().nullable(),
  additionalData: z.any(),
});

export type JupiterCustomSubscription = z.infer<typeof JupiterCustomSubscription>;
